import { useAuth } from '@clerk/nextjs';
import { ResolvedFeatures } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  features: ResolvedFeatures;
};

export function useFeatures() {
  const { orgId } = useAuth();

  return useQuery<ResolvedFeatures>({
    queryKey: [Query.CustomerKeys['features'], { orgId }],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/features`);
      return resp.data.features;
    },
  });
}
